// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-sm":"(min-width: 768px)","mediaBreakpointSm":"(min-width: 768px)","recommended-list":"_1Jg9QiXM mt3","recommendedList":"_1Jg9QiXM mt3"};